import { useApp } from '@packages/hooks/useApp';
import { applyRef } from '@packages/react/applyRef';
import { namedComponent } from '@packages/react/lib/named';
import { RouterServiceProvider } from '@packages/router/lib/RouterServiceProvider';
import React from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

interface ComponentLinkProps extends Omit<LinkProps, 'to' | 'props'> {
    to: any;
    props?: { [key: string]: any };
}

/**
 * Linked Router Link component
 * @param props$
 * @returns {*}
 * @constructor
 */
export const Link = namedComponent<ComponentLinkProps>(
    React.forwardRef((props$, ref$) => {
        const { to, props, component, ...rest } = props$;
        const router = useApp(RouterServiceProvider);
        const to$ = typeof to === 'string' ? router.route(to, props || {}) : to;

        applyRef(rest, ref$);

        return <RouterLink component={Enhancer(component as any) as any} to={to$} {...rest} />;
    }),
    'Link',
);

const Enhancer = (Component: React.ElementType) => {
    if (Component) {
        return ({ navigate, ...rest }) => <Component {...rest} />;
    }

    return Component;
};
